import { Link } from "react-router-dom";
import { BRAND } from "@/config/brand";
import { FOOTER_NAV } from "@/config/nav";

export default function PublicFooter() {
  const whatsappNumber = BRAND.whatsapp.replace(/\D/g, "");

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-accent-500 text-secondary-950 font-heading font-bold text-sm">
                {BRAND.initials}
              </span>
              <span className="font-heading font-semibold text-base text-background-50">{BRAND.name}</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/80">
              {BRAND.description}
            </p>
            <ul className="mt-5 flex flex-col gap-2 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" aria-hidden="true" />
                {BRAND.address}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" aria-hidden="true" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-background-50">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400" aria-hidden="true" />
                <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="hover:text-background-50">
                  {BRAND.phone}
                </a>
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
            {FOOTER_NAV.map((column) => (
              <div key={column.title}>
                <h4 className="text-xs font-label font-semibold uppercase tracking-wide text-accent-400">
                  {column.title}
                </h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {column.items.map((item) => (
                    <li key={item.label}>
                      <Link
                        to={item.to}
                        className="block text-sm text-background-200/85 hover:text-background-50 transition-colors"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70 text-center sm:text-left">
            © {BRAND.year} {BRAND.name}. Tous droits réservés. {BRAND.country}.
          </p>
          <div className="flex items-center gap-3">
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="flex items-center justify-center w-9 h-9 rounded-full bg-background-50/10 text-background-100 hover:bg-accent-500 hover:text-secondary-950 transition-colors"
            >
              <i className="ri-whatsapp-line" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}